export default __webpack_public_path__ + "static/1-65683240db5a5e32db5cec9525ea8985.jpg";